import Vue from 'vue'
import axios from 'axios'; // 引入axios
import store from '@/store/index';
import router from '../router/index';
import {
  Message,
} from 'element-ui'
import md5 from 'js-md5';
const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL, // api base_url
  timeout: 120000 // 请求超时时间
})
const err = (error) => {
  if (error.response) {
    let data = error.response.data
    let token = Vue.ls.get('token')
    switch (error.response.status) {
      case 403:
        Message.error('很抱歉，拒绝访问');
        break
      case 500:
        Message.error('很抱歉，系统错误');
        break
      case 404:
        Message.error('很抱歉，资源超时');
        break
      case 504:
        Message.error('很抱歉，网络超时');
        break
      case 401:
        Message.error('很抱歉，登录已过期，请重新登录');
        if (token) {
          Vue.ls.remove('token')
        }
        store.commit("settoken", null);
        store.commit("setuserinfo", null);
        router.pusn('/')
        store.commit("setloginstate", true);
        // console.log(store.state.loginstate);
        break
      default:
        Message.error(data.message);
        break
    }
  } else if (error.message) {
    // console.log(error.message)
    if (error.message.includes('timeout')) {
      Message.error('很抱歉，网络超时');
    } else {
      Message.error(error.message);
    }
  }
  return Promise.reject(error)
};
// 请求拦截器
service.interceptors.request.use(
  config => {
    let token = Vue.ls.get('token');
    let timestamp = new Date().getTime()
    config.headers['X-SESSION-TIMESTAMP'] = timestamp
    config.headers['X-SESSION-SIGN'] = md5(`${token}public_chuyue${timestamp}`)
    if (token) {
      config.headers['X-Access-Token'] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
    }
    return config
  },
  error => {
    return Promise.error(error);
  })
// 响应拦截器
service.interceptors.response.use((response) => {
  if (response.data == '访问超时，请稍后再试!') {
    Message.error(response.data);
  } else {
    return response.data;
  }
}, err)


export {
  service
}